import { AlertCircle, CheckCircle2, MessageSquare } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useRightSidebarProject } from "../../../contexts";
import { useActiveTeamsTenant, useProject } from "../../../hooks/useProjectData";

export function TeamsPanel() {
  const { projectId } = useRightSidebarProject();
  const project = useProject(projectId);
  const tenant = useActiveTeamsTenant(project?.orgId ?? null);

  if (project === undefined || tenant === undefined) {
    return (
      <div className="flex items-center justify-center h-full">
        <p className="text-sm text-muted-foreground">Loading Teams status...</p>
      </div>
    );
  }

  return (
    <ScrollArea className="flex-1 px-4">
      <div className="space-y-4 py-4">
        <div>
          <div className="mb-2 flex items-center gap-2">
            <MessageSquare className="size-4 text-muted-foreground" />
            <h3 className="text-sm font-medium">Teams consultations</h3>
          </div>
          <p className="text-sm text-muted-foreground">
            Teams chats are created from open clarification requests with Invite via Teams.
          </p>
        </div>

        {tenant ? (
          <div className="rounded-md border p-3">
            <div className="mb-2 flex items-center justify-between gap-2">
              <div className="flex min-w-0 items-center gap-2">
                <CheckCircle2 className="size-4 text-emerald-600" />
                <span className="truncate text-sm font-medium">
                  {tenant.displayName ?? tenant.microsoftTenantId}
                </span>
              </div>
              <Badge variant="outline">{tenant.status}</Badge>
            </div>
            <dl className="space-y-1 text-xs text-muted-foreground">
              <div className="flex justify-between gap-3">
                <dt>RSC</dt>
                <dd>{tenant.rscStatus}</dd>
              </div>
              <div className="flex justify-between gap-3">
                <dt>Catalog app</dt>
                <dd className="truncate">{tenant.catalogAppId ?? "Not set"}</dd>
              </div>
            </dl>
            {tenant.lastFailure && (
              <p className="mt-3 text-xs text-destructive">{tenant.lastFailure.message}</p>
            )}
          </div>
        ) : (
          <div className="rounded-md border p-3 text-sm text-muted-foreground">
            <div className="mb-2 flex items-center gap-2 text-foreground">
              <AlertCircle className="size-4" />
              <span className="font-medium">Teams is not configured</span>
            </div>
            Organization admins need to configure and approve the Decision Formula Teams app before
            consultations can be started.
          </div>
        )}
      </div>
    </ScrollArea>
  );
}
